import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"

import { useHistory } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 420,
		border: "1px solid #DADADA",
	},
}))

const ViewerView = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()

	return <Box className={classes.root}>123</Box>
}

export default ViewerView
